import { createSlice } from "@reduxjs/toolkit";
import { getListTrademarkCompanyMap } from "../../api/Trademark/TrademarkCompanyMap";

// giá trị khởi tạo của state
const initialState = {
  listTrademarkCompanyMap: [],
  isLoadTrademarkMap: false,
  currentPage: 1,
  pageSize: 10,
  // hasFetchedData: false,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API  
};

const trademarkCompanyMapSlice = createSlice({
  name: "trademarkCompanyMap", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload; // Sửa lỗi gán nhầm `pageSize`
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListTrademarkCompanyMap.pending, (state) => {// api đnag pending chờ xử lý
        state.isLoadTrademarkMap = true;
        state.error = null;
      })
      .addCase(getListTrademarkCompanyMap.fulfilled, (state, action) => {// api trả về thành công thì trả ra
        state.isLoadTrademarkMap = false;
        state.listTrademarkCompanyMap = action.payload.data || [];

        state.isLoadTrademarkMap = false;
        state.currentPage = action.payload.current_page; // Cập nhật trang hiện tại từ API
        state.pageSize = action.payload.per_page; // Cập nhật số bản ghi mỗi trang
        state.totalRecords = action.payload.total; // Cập nhật tổng số bản ghi
      })
      .addCase(getListTrademarkCompanyMap.rejected, (state, action) => {// api trả về thất bại thì trả ra
        state.isLoadTrademarkMap = false;
        state.error = action.payload;
        // state.error = action.error?.message || "Lỗi không xác định";
      });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } = trademarkCompanyMapSlice.actions;
export default trademarkCompanyMapSlice.reducer;
